import {
  ShoppingBag,
  Globe,
  Code2,
  Palette,
  Store,
  LifeBuoy,
  Search,
  Layers,
  Smartphone,
  Database,
  Shield,
  Activity,
} from "lucide-react";

export const SERVICES = [
  {
    id: "shopify",
    icon: ShoppingBag,
    title: "Shopify Development",
    short: "Custom Shopify stores built for conversions and growth.",
    bullets: [
      "Custom Shopify Stores",
      "Theme Development",
      "Store Optimization",
      "Shopify Migration",
    ],
  },
  {
    id: "wordpress",
    icon: Globe,
    title: "WordPress Development",
    short: "Flexible and scalable WordPress websites.",
    bullets: [
      "Corporate Websites",
      "WooCommerce Stores",
      "Elementor Development",
      "Website Redesign",
    ],
  },
  {
    id: "ecommerce",
    icon: Store,
    title: "Ecommerce Solutions",
    short: "Online stores designed for maximum sales.",
    bullets: ["Shopify", "WooCommerce", "Custom Ecommerce"],
  },
  {
    id: "custom",
    icon: Code2,
    title: "Custom Development",
    short: "Tailored business solutions and web applications.",
    bullets: [
      "React Applications",
      "Node.js Solutions",
      "Booking Systems",
      "Dashboards & Portals",
    ],
  },
  {
    id: "design",
    icon: Palette,
    title: "UI/UX Design",
    short: "Beautiful experiences that convert visitors into customers.",
    bullets: ["Research", "Wireframing", "Prototyping", "Design Systems"],
  },
  {
    id: "maintenance",
    icon: LifeBuoy,
    title: "Maintenance & Support",
    short: "Ongoing support and optimization.",
    bullets: ["Updates", "Security", "Monitoring", "Backups"],
  },
];

export const SERVICE_DETAILS = {
  shopify: {
    icon: ShoppingBag,
    title: "Shopify Development",
    description:
      "Premium Shopify storefronts engineered for conversion, speed and scale — from theme builds to complete platform migrations.",
    items: [
      { icon: Store, label: "Custom Shopify Stores" },
      { icon: Palette, label: "Theme Development" },
      { icon: Activity, label: "Store Optimization" },
      { icon: Database, label: "Shopify Migration" },
    ],
  },
  wordpress: {
    icon: Globe,
    title: "WordPress Development",
    description:
      "Flexible WordPress and WooCommerce experiences with thoughtful information architecture and editorial polish.",
    items: [
      { icon: Layers, label: "Corporate Websites" },
      { icon: ShoppingBag, label: "WooCommerce Stores" },
      { icon: Palette, label: "Elementor Development" },
      { icon: Activity, label: "Website Redesign" },
    ],
  },
  ecommerce: {
    icon: Store,
    title: "Ecommerce Solutions",
    description:
      "Conversion-focused commerce experiences across platforms — Shopify, WooCommerce and fully custom stacks.",
    items: [
      { icon: ShoppingBag, label: "Shopify" },
      { icon: Globe, label: "WooCommerce" },
      { icon: Code2, label: "Custom Ecommerce" },
    ],
  },
  custom: {
    icon: Code2,
    title: "Custom Development",
    description:
      "Tailored web applications, internal tools and digital products — engineered with modern React, Node.js and cloud infrastructure.",
    items: [
      { icon: Smartphone, label: "React Applications" },
      { icon: Database, label: "Node.js Solutions" },
      { icon: Layers, label: "Booking Systems" },
      { icon: Activity, label: "Dashboards & Portals" },
    ],
  },
  design: {
    icon: Palette,
    title: "UI/UX Design",
    description:
      "End-to-end product design — research, wireframing, prototyping and design systems for scaling brands.",
    items: [
      { icon: Search, label: "Research" },
      { icon: Layers, label: "Wireframing" },
      { icon: Palette, label: "Prototyping" },
      { icon: Code2, label: "Design Systems" },
    ],
  },
  maintenance: {
    icon: LifeBuoy,
    title: "Maintenance & Support",
    description:
      "Always-on partnership for performance, security and continuous improvement of your web platform.",
    items: [
      { icon: Activity, label: "Updates" },
      { icon: Shield, label: "Security" },
      { icon: Search, label: "Monitoring" },
      { icon: Database, label: "Backups" },
    ],
  },
};

export const PROCESS_STEPS = [
  {
    label: "Discovery",
    body: "We dive deep into your business, customers and goals to define what success looks like.",
  },
  {
    label: "Strategy",
    body: "We craft a clear product, content and growth strategy with measurable KPIs.",
  },
  {
    label: "Design",
    body: "Brand-aligned UI/UX that turns visitors into customers and reflects your premium positioning.",
  },
  {
    label: "Development",
    body: "Engineered with modern frameworks, performance budgets and SEO best practices.",
  },
  {
    label: "Launch",
    body: "QA, accessibility, analytics setup and a calm, controlled go-live.",
  },
  {
    label: "Growth",
    body: "Ongoing optimization, A/B testing and iteration to grow the metrics that matter.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Coding Solutions delivered a Shopify storefront that out-performed our previous site within weeks. Their attention to UX detail is rare.",
    author: "Marcus Hoffmann",
    title: "Founder, Thomsen Germany",
  },
  {
    quote:
      "From discovery to launch, the team felt like an extension of ours. Our conversion rate is up 41% three months in.",
    author: "Priya Nair",
    title: "Head of Ecommerce, The Luxe Attire",
  },
  {
    quote:
      "They translated a complex sports-analytics product into a clean, intuitive web platform. Truly world-class engineering.",
    author: "Daniel Roy",
    title: "CEO, Playtics",
  },
  {
    quote:
      "Beautiful design, fast site, and a partnership that just works. We could not recommend them more highly.",
    author: "Sophia Becker",
    title: "Director, SoulBaby",
  },
];
